import { Injectable } from '@angular/core';
import { HashLocationStrategy, PathLocationStrategy, PlatformLocation } from '@angular/common';

@Injectable()
export class CustomLocationStrategy extends HashLocationStrategy {
  constructor(private platformLocation: PlatformLocation) {
    super(platformLocation);
  }

  prepareExternalUrl(internal: string): string {
    // If it's activation link, privacy policy, or terms and conditions, use path-based URL
    if (internal.startsWith('/activationlink') || 
        internal.startsWith('/privacy-policy') || 
        internal.startsWith('/terms-conditions')) {
      return internal;
    }
    // For all other routes, use hash-based URL
    return super.prepareExternalUrl(internal);
  }

  path(includeHash?: boolean): string {
    const path = this.platformLocation.pathname + this.platformLocation.search;
    // If current path is activation link, privacy policy, or terms and conditions, return it as-is
    if (path.startsWith('/activationlink') || 
        path.startsWith('/privacy-policy') || 
        path.startsWith('/terms-conditions')) {
      return path;
    }
    // For other paths, use hash strategy
    return super.path(includeHash);
  }
}


// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/custom-location-strategy.ts